import { DateTime } from 'luxon';

// Acceptable input patterns we might receive from API
const INPUT_PATTERNS = [
  'HH:mm', // 06:00
  'HH:mm:ss', // 06:00:00
  'HH:mm:ss.SSS', // 06:00:00.000
];

export const parseOperationTime = (time: string | null | undefined): DateTime | null => {
  if (!time) return null;

  for (let i = 0; i < INPUT_PATTERNS.length; i += 1) {
    const fmt = INPUT_PATTERNS[i];
    const dt = DateTime.fromFormat(time, fmt);
    if (dt.isValid) {
      return dt;
    }
  }

  // try plain 24h without colon (e.g., '0000')
  if (/^\d{4}$/.test(String(time))) {
    const dt = DateTime.fromFormat(String(time), 'HHmm');
    if (dt.isValid) return dt;
  }

  return null;
};

export const isSameTimeOfDay = (a: DateTime, b: DateTime): boolean =>
  a.toFormat('HH:mm:ss.SSS') === b.toFormat('HH:mm:ss.SSS');

export const is24HourOperation = (open?: string | null, close?: string | null): boolean => {
  const openDt = parseOperationTime(open ?? undefined);
  const closeDt = parseOperationTime(close ?? undefined);
  if (!openDt || !closeDt) return false;

  return isSameTimeOfDay(openDt, closeDt);
};
